import { render, staticRenderFns } from "./RegionTotals.vue?vue&type=template&id=7bc7ff36"
import script from "./RegionTotals.vue?vue&type=script&lang=ts"
export * from "./RegionTotals.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports